// extracted by mini-css-extract-plugin
module.exports = {"carouselRightArrow":"CarouselRightArrow-module__carouselRightArrow___2Cuvm","studio":"CarouselRightArrow-module__studio___9De-k"};